import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getConditionalPaletteSpread } from 'reporting-visualizations/utils/conditionalFormatterUtils';
import { useConditionalPalettes } from 'reporting-visualizations/hooks/useConditionalPalettes';
import ColorPicker from '../shared-components/ColorPicker';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import { BandType } from './utils';
import { Button } from 'foundations-components/transitional/components/Button';
import { DeleteIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_PALETTE_ID = 'WhiteToOrange';
const VALID_KEY_INPUTS = ['Backspace', '-', 'Shift', 'Control', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'ArrowDown', 'Tab', 'Return', '.'];
const ColorInput = ({
  currentColor,
  currentPalette = DEFAULT_PALETTE_ID,
  bandType,
  onColorChange
}) => {
  var _conditionalPalettes$;
  const conditionalPalettes = useConditionalPalettes();
  const paletteSpread = getConditionalPaletteSpread({
    paletteId: currentPalette,
    count: 10,
    opacity: 1,
    conditionalPalettes
  }).map(hex => hex.substring(0, 7));
  const paletteMidValue = paletteSpread.length > 1 ? paletteSpread[Math.floor(paletteSpread.length / 2) - 1] : '';
  const currentPaletteColors = ((_conditionalPalettes$ = conditionalPalettes[currentPalette]) === null || _conditionalPalettes$ === void 0 ? void 0 : _conditionalPalettes$.colors) || conditionalPalettes[DEFAULT_PALETTE_ID].colors;
  const minResetValue = currentPaletteColors.minColor;
  const maxResetValue = currentPaletteColors.maxColor;
  const midResetValue = currentPaletteColors.midColor || paletteMidValue;
  switch (bandType) {
    case BandType.MIN:
      return /*#__PURE__*/_jsx(ColorPicker, {
        value: currentColor || minResetValue,
        onChange: color => onColorChange(color),
        grid: paletteSpread,
        resetValue: minResetValue,
        size: 40
      });
    case BandType.MAX:
      return /*#__PURE__*/_jsx(ColorPicker, {
        value: currentColor || maxResetValue,
        onChange: color => onColorChange(color),
        grid: paletteSpread,
        resetValue: maxResetValue,
        size: 40
      });
    case BandType.MID:
      return /*#__PURE__*/_jsx(ColorPicker, {
        value: currentColor || midResetValue,
        onChange: color => onColorChange(color),
        grid: paletteSpread,
        resetValue: midResetValue,
        size: 40
      });
    default:
      return null;
  }
};
const ConditionalFormattingMinAndMaxInputControl = ({
  currentValue,
  onChange,
  bandType,
  currentColor,
  currentPalette,
  onColorChange,
  error,
  validationMessage,
  selectedDuration,
  onRemoveMidpoint
}) => {
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `report-customization-components.customization-components.conditional-formatting.min-max-controls.${bandType}.label`
    }),
    error: error,
    validationMessage: error ? validationMessage : '',
    children: /*#__PURE__*/_jsxs(Flex, {
      children: [/*#__PURE__*/_jsx(View, {
        inlineSize: "100px",
        marginInlineEnd: "200",
        children: /*#__PURE__*/_jsx(NumberInput, {
          error: error,
          onKeyDown: e => {
            const key = e.key;
            if (isNaN(parseInt(key, 10)) && !VALID_KEY_INPUTS.includes(key)) {
              e.preventDefault();
            }
          },
          onChange: e => {
            var _e$target;
            onChange(e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
          },
          precision: 2,
          value: currentValue,
          placeholder: I18n.text('report-customization-components.customization-components.conditional-formatting.min-max-controls.auto')
        })
      }), selectedDuration && /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "300",
        as: "div",
        children: selectedDuration
      }), /*#__PURE__*/_jsx(ColorInput, {
        currentColor: currentColor,
        bandType: bandType,
        onColorChange: onColorChange,
        currentPalette: currentPalette
      }), bandType === BandType.MID && /*#__PURE__*/_jsx(Tooltip, {
        title: I18n.text('report-customization-components.customization-components.conditional-formatting.remove-mid-button'),
        placement: "right",
        children: /*#__PURE__*/_jsx(Button, {
          use: "link",
          onClick: onRemoveMidpoint,
          marginInlineStart: "200",
          children: /*#__PURE__*/_jsx(DeleteIcon, {
            size: "400"
          })
        })
      })]
    })
  });
};
export default ConditionalFormattingMinAndMaxInputControl;